import React, { Component } from "react";
import { Dialog, InputGroup, Button } from "@blueprintjs/core";
import { validate } from "validate.js";
import { Translate , I18n} from "react-redux-i18n";
import LoadingIndicator from "../../../components/LoadingIndicator";

export default class RecoverPasswordDialog extends Component {
  state = {
    form: {
      u_name: ""
    },
    validation_errors: {}
  };

  updateFields=(event)=>{
    this.setState({
        form: {
        ...this.state.form,
        [event.target.id]: event.target.value
      }
    });
  }
  submitForm=(e)=>{
    e.preventDefault();
    const validationErrors = validate(
      this.state.form,
      this.props.validators
    );

    this.setState({
      validation_errors: validationErrors ? validationErrors : {}
    });

    if (!validationErrors) {
      this.props.onRecoverPassword(this.state.form.u_name);
    }
  }  
  
  render() {
    return (
      <Dialog
        onClose={this.props.onClose}
        title={I18n.t("recover_password.heading")}
        autoFocus={true}
        canEscapeKeyClose={false}
        canOutsideClickClose={false}
        enforceFocus={true}
        isOpen={this.props.isOpen}
        usePortal={true}>
        <div className="dialog-wrapper">
          <form onSubmit={this.submitForm} className="login-form">
            <div
              className={
                this.state.validation_errors.u_name
                  ? "form-group error"
                  : "form-group"
              }>
              {this.state.validation_errors.u_name && (
                <label htmlFor="u_name">
                  <Translate value={this.state.validation_errors.u_name} />
                </label>
              )}
              <InputGroup
                leftIcon="lock"
                type="email"
                placeholder={I18n.t("recover_password.email_placeholder")}
                fill={true}
                id="u_name"
                disabled={this.props.isLoading}
                intent={this.state.validation_errors.u_name ? "danger" : ""}
                onChange={this.updateFields}
              />
            </div>
            
            {this.props.isLoading && <LoadingIndicator />}
            {!this.props.isLoading && (
              <Button
                disabled={this.props.isLoading}
                className="login-button"
                intent="primary"
                fill={true}
                type="submit">
                <Translate value="recover_password.button" />
              </Button>
            )}             
          </form>
        </div>
      </Dialog>
    );
  }
}
